import { Component, Input,  } from "@angular/core";
import { PopupFieldData } from "src/app/features/designer-studio/edit-pdf-doc/models/doc.model";
@Component({
  selector: "app-screen-input",
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.scss"],
})
export class InputComponent {
  @Input() initOptions: PopupFieldData;
}
